// @flow
/* eslint-disable import/prefer-default-export */
export const AMOUNT_PER_PAGE: number = 10;
